// 🎯 ONEIMC 人臉識別系統動態配置
// 此文件允許輕鬆調整人臉識別參數，無需修改 Python 後端代碼

export const FACE_CONFIG = {
  // 📸 照片數量配置 - 方案1：保守提升精度
  REQUIRED_PHOTOS: 10,  // 從8張提高到10張，平衡精度和用戶體驗
  
  // 📷 相機設定
  CAMERA_RESOLUTION: {
    width: { ideal: 1920, min: 1280 },
    height: { ideal: 1080, min: 720 }
  },
  
  // 🖼️ 照片品質設定
  JPEG_QUALITY: 0.95,  // JPEG 壓縮品質 (0.1-1.0)
  
  // 📋 拍攝指引配置 (依照片數量動態調整)
  getPhotoGuides: (requiredPhotos) => {
    const allGuides = [
      { id: 1, title: '正面照', description: '請正視鏡頭，面部居中，保持自然表情', icon: '😐' },
      { id: 2, title: '微笑照', description: '請保持自然微笑，眼睛看鏡頭', icon: '😊' },
      { id: 3, title: '左轉照', description: '請將頭部向左轉約30度，眼睛仍看鏡頭', icon: '🙂' },
      { id: 4, title: '右轉照', description: '請將頭部向右轉約30度，眼睛仍看鏡頭', icon: '🙃' },
      { id: 5, title: '低頭照', description: '請將頭部稍微向下低，眼睛向上看鏡頭', icon: '😌' },
      { id: 6, title: '抬頭照', description: '請將頭部稍微向上仰，眼睛向下看鏡頭', icon: '😎' },
      { id: 7, title: '左斜照', description: '請將頭部向左下方傾斜，保持正視鏡頭', icon: '🤔' },
      { id: 8, title: '右斜照', description: '請將頭部向右下方傾斜，保持正視鏡頭', icon: '😏' },
      { id: 9, title: '半側照', description: '請將頭部轉向45度角，展現側面輪廓', icon: '🤨' },
      { id: 10, title: '眯眼照', description: '請輕微眯眼，但仍能看到瞳孔', icon: '😑' },
      { id: 11, title: '張嘴照', description: '請輕微張開嘴巴，保持自然表情', icon: '😮' },
      { id: 12, title: '遠距照', description: '請稍微遠離鏡頭，展現完整面部', icon: '🙂' }
    ];
    
    // 根據需要的照片數量返回對應的指引
    return allGuides.slice(0, requiredPhotos);
  },
  
  // ⚙️ 版本資訊
  VERSION: 'V15-高精度',
  
  // 📝 配置說明
  CONFIG_NOTES: {
    '5張照片': '基礎配置，適合快速註冊',
    '8張照片': '標準配置，平衡精度和速度',
    '10張照片': '高精度配置，適合安全要求較高的場景',
    '12張照片': '極高精度配置，提供最佳識別效果'
  }
};

// 🔧 預設配置組合
export const PRESET_CONFIGS = {
  QUICK: { photos: 5, version: 'V14-快速版' },
  STANDARD: { photos: 10, version: 'V14-標準版' },
  HIGH_ACCURACY: { photos: 10, version: 'V14-高精度版' },
  ULTRA_ACCURACY: { photos: 12, version: 'V14-極高精度版' }
};

// 使用範例:
// import { FACE_CONFIG, PRESET_CONFIGS } from './config/faceRecognitionConfig';
// const requiredPhotos = FACE_CONFIG.REQUIRED_PHOTOS;
// const photoGuides = FACE_CONFIG.getPhotoGuides(requiredPhotos);